import { Action } from '@ngrx/store';
export const CREATE_NOTIFICATION = '[Notification] CREATE_NOTIFICATION';
export const REMOVE_NOTIFICATION = '[Notification] REMOVE_NOTIFICATION';

export class CreateNotification implements Action {
  readonly type = CREATE_NOTIFICATION;
  constructor(public payload: string) {}
}
export class RemoveNotification implements Action {
  readonly type = REMOVE_NOTIFICATION;
}

export type NotificationActions = CreateNotification | RemoveNotification;
